import type { RouteObject } from "react-router";
import { useLocation, useRoutes } from "react-router-dom";
import Login from "../pages/login";
import WrapperRouteComponent from "./WrapperRouteComponent";
import Home from "pages/home";
import Trading from "pages/trading";
import Header from "components/Header";
import Market from "pages/market";
import useBreakpoint from "hooks/useBreakpoint";
import Tabbar from "components/Tabbar";
import Wallet from "pages/wallet";
import Register from "pages/register";
import Deposit from "pages/deposit";
import Withdraw from "pages/withdraw";
import ForgotPassword from "pages/forgot-password";
import { useEffect } from "react";
import AccountSetting from "pages/account-setting";
import KycPage from "pages/kyc";
import TradingFutrue from "pages/futrue";
import Invest from "pages/invest";
import RefUser from "pages/ref-user";
const routeList: RouteObject[] = [
  {
    path: "/",
    element: <WrapperRouteComponent element={<Home />} />,
  },
  {
    path: "/trading",
    element: <WrapperRouteComponent element={<Trading />} />,
  },
  {
    path: "/trading-future",
    element: <WrapperRouteComponent element={<TradingFutrue />} />,
  },
  {
    path: "/market",
    element: <WrapperRouteComponent element={<Market />} />,
  },
  {
    path: "/asset",
    element: <WrapperRouteComponent element={<Wallet />} />,
  },
  {
    path: "/deposit",
    element: <WrapperRouteComponent element={<Deposit />} />,
  },
  {
    path: "/withdraw",
    element: <WrapperRouteComponent element={<Withdraw />} />,
  },
  {
    path: "/login",
    element: <WrapperRouteComponent element={<Login />} />,
  },
  {
    path: "/register",
    element: <WrapperRouteComponent element={<Register />} />,
  },
  {
    path: "/account-setting",
    element: <WrapperRouteComponent element={<AccountSetting />} />,
  },
  {
    path: "/account-kyc",
    element: <WrapperRouteComponent element={<KycPage />} />,
  },
  {
    path: "/forgot-password",
    element: <WrapperRouteComponent element={<ForgotPassword />} />,
  },
  {
    path: "/invest",
    element: <WrapperRouteComponent element={<Invest />} />,
  },
  {
    path: "/ref-user",
    element: <WrapperRouteComponent element={<RefUser />} />,
  },
];
const RenderRouter = () => {
  const element = useRoutes(routeList);
  const breakpoint = useBreakpoint();

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex flex-col w-full">
      <Header />
      <div className="flex-1 ">{element}</div>
      {!(pathname === "/login" || pathname === "/register") && <Tabbar />}
    </div>
  );
};

export default RenderRouter;
